import { type PropsWithChildren, forwardRef } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";
import type { ButtonProps } from "./Button.types";

const Button = forwardRef<HTMLButtonElement, PropsWithChildren<ButtonProps>>(
  (
    {
      className,
      isLoading,
      disabled,
      type,
      theme = "primary",
      size = "medium",
      outlined,
      children,
      ...buttonProps
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        type={type || "button"}
        aria-busy={isLoading}
        className={cn(
          "text-snow h-fit flex items-center justify-center gap-2 rounded-md font-medium transition-all duration-200 hover:opacity-75 hover:shadow-sm active:opacity-50 disabled:cursor-not-allowed disabled:opacity-50 aria-busy:cursor-wait",
          {
            "bg-primary text-white": theme === "primary",
            "bg-secondary text-white": theme === "secondary",
            "bg-danger text-white": theme === "danger",
          },
          {
            "px-3 py-1.5": size === "small",
            "px-4 py-2": size === "medium",
            "px-6 py-3": size === "large",
          },
          outlined && "bg-snow border border-tertiary-700 text-tertiary-700",
          className,
        )}
        disabled={disabled || isLoading}
        {...buttonProps}
      >
        {children} {isLoading && <span>Loading...</span>}
      </button>
    );
  },
);

Button.displayName = "Button";

export default Button;
